module.exports = __webpack_public_path__ + "img/empty.3cc0728f.png";